import InputNumber from './input-number';
export default InputNumber;
